import { h } from 'preact'

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const Post = props => {
  const { post } = props

  const title = post.title.rendered
  const image = post.featured_image_link
  const content = post.excerpt.rendered
  const shortContent = content ? content.slice(0, 150) : false
  const displayShortContent = shortContent.length > 1 ? `${shortContent}...` : false
  const renderContent = content.length < 150 ? content : displayShortContent
  const price = post.price && post.price != 0 && props.language !== 'en' ? post.price : false
  const currency = post.currency_symbol
  const volume = post.product_attributes ? post.product_attributes : false
  const productType = post.product_type ? post.product_type : false
  const anchorPet = props.add
  const anchorVet = props.readMore
  const formattedPrice = price 
    ? props.language == 'no' || props.language == 'da' || props.language == 'sv'
      ? price.replace('.', ',') + ' ' + currency 
      : currency + price.replace('.', ',') 
    : false
  const url = post.link
  const loggedIn = props.loggedIn;

  const fromArray = [
    { id: '', title: 'From' },
    { id: 'en', title: 'From' },
    { id: 'at', title: 'Ab' },
    { id: 'be', title: 'Vanaf' },
    { id: 'da', title: 'Fra' },
    { id: 'fi', title: 'Alkaen' },
    { id: 'fr', title: 'A partir de' },
    { id: 'fr-be', title: 'A partir de' },
    { id: 'de', title: 'Ab' },
    { id: 'ga', title: 'From' },
    { id: 'it', title: 'A partire da' },
    { id: 'lu', title: 'Ab' },
    { id: 'nl', title: 'Vanaf' },
    { id: 'no', title: 'Fra' },
    { id: 'pl', title: 'Od' },
    { id: 'pt-pt', title: 'A partir de' },
    { id: 'es', title: 'Desde' },
    { id: 'sv', title: 'Från' },
    { id: 'ch', title: 'Ab' },
    { id: 'uk', title: 'From' },
    { id: 'gb', title: 'From' },
    { id: 'us', title: 'From' }
  ]
  let fromLabel = (productType == 'variable' && price) ? fromArray.find(
    ({ id }) => id === props.language
  ) : false;
  fromLabel = fromLabel.title ? fromLabel.title : false;

  return (
    <a href={url} className={`c-shop-overview__post c-shop-item`}>
      <div className="c-shop-item__image-wrapper">
        <div className="c-shop-item__image-container u-image">
          <img src={image} className="c-shop-item__image u-image__background" alt={title} />
        </div>
      </div>

      <div className="c-shop-item__content-container">
        <h3 className="c-shop-item__title">
          <div dangerouslySetInnerHTML={{ __html: title }} />
        </h3>

        <p className="c-shop-item__content">
          <div dangerouslySetInnerHTML={{ __html: renderContent }} />
        </p>
      </div>

      {(productType != 'variable' && props.language !== 'en') && loggedIn == "true" || props.language !== 'en' && loggedIn == "true" ? (
        <div className="c-shop-item__button-container u-flex">
          <div className="c-shop-item__price-container">
            {/* {fromLabel ? (
              <div className="c-shop-item__from">{fromLabel}</div>
            ) : null} */}
            {/* <div className="c-shop-item__price" dangerouslySetInnerHTML={{ __html: formattedPrice }} /> */}
            <div className="c-shop-item__volume">{volume}</div>
          </div>

          <div className="c-shop-item__button">
            {anchorVet}

            <svg className="c-icon c-shop-item__icon">
              <use href="#plus" xlinkHref="#plus" />
            </svg>
          </div>
        </div>
      ) : (
        <div className="c-shop-item__button-container u-flex">
          <div className="c-shop-item__price-container">
            <div className="c-shop-item__volume">{volume}</div>
          </div>

          <div className="c-shop-item__button">
            {anchorVet}

            <svg className="c-icon c-shop-item__icon">
              <use href="#plus" xlinkHref="#plus" />
            </svg>
          </div>
        </div>
      )}
    </a>
  )
}

export default Post


// WEBPACK FOOTER //
// ./src/js/shop/components/Post.js